import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { NoPageFoundComponent } from './components/no-page-found/no-page-found.component';
import { HeaderComponent } from './components/header/header.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { SharedModule } from './modules/shared/shared.module';
import { ReviewsComponent } from './components/reviews/reviews.component';
// import { AgmCoreModule } from '@agm/core';
import { ScrollTopModule } from 'primeng/scrolltop';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { SEOService } from './service/seo.service';
import { VoitureService } from './service/voiture.service';
import { MailService } from './service/mail.service';
import { IntercepteurHttp } from './service/intercepteur-http';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    NoPageFoundComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    ScrollTopModule,
    FontAwesomeModule
  ],
  exports: [],
  providers: [SEOService, VoitureService, MailService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: IntercepteurHttp,
      multi: true
    },
    {
      provide: LOCALE_ID,
      useValue: 'fr-FR'
    }],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor() {
    library.add(fas);
  }
}
